import Highlighter from "react-highlight-words";
import classNames from "classnames";

export interface SearchAutocompleteTagProps {
  section: string;
  searchTerm: string;
  ein?: string;
  name: string;
  url?: string;
}

const Highlight = ({ children }: any) => (
  <span className="tw:font-semibold">{children}</span>
);

export function SearchAutocompleteTag(props: SearchAutocompleteTagProps) {
  // Custom event trigger
  const triggerCustomEvent = (e: any) => {
    console.log("SearchAutocompleteTag clicked:");
    e.preventDefault();

    // Create custom event
    var event = new CustomEvent("autocomplete-term-clicked", {
      detail: {
        name: props.name,
        searchTerm: props.searchTerm,
        section: props.section,
        url: props.url,
      },
    });

    // Trigger custom event
    document.dispatchEvent(event);

    if (props.url) {
      window.location.href = props.url;
    }
  };

  return (
    <a
      key={props.ein}
      href={props.url}
      className={classNames(
        "tw:inline-block tw:font-sofia-pro tw:font-normal tw:text-base tw:leading-6 tw:tracking-normal tw:text-left",
        "tw:transition-colors tw:!no-underline tw:text-night-sky-800 tw:!bg-gray-50 tw:hover:!bg-gray-100",
        "tw:rounded-lg tw:pt-2 tw:pb-2 tw:pl-3 tw:pr-3 tw:m-1 tw:ring-1 tw:ring-offset-2 tw:ring-transparent",
        "autocomplete-tag",
      )}
      data-section={props.section}
      data-testid="searchAutocompleteTag"
      onClick={(e) => triggerCustomEvent(e)}
    >
      {props.searchTerm === "" ? (
        <span className="tw:font-semibold">{props.name}</span>
      ) : (
        <Highlighter
          highlightTag={Highlight}
          searchWords={[props.searchTerm]}
          textToHighlight={props.name}
        />
      )}
    </a>
  );
}
